import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  SPECIAL_FARE_DISABLED_TOOLTIP,
  SPECIAL_FARE_INFO_ICON_PX,
  SPECIAL_FARE_INFO_TARGET_PX,
  SPECIAL_FARE_META,
  SPECIAL_FARE_TOOLTIP_SLOT_PROPS,
} from './flightForm.constants';

export function wrapSpecialFarePill(fareKey, pill, { disabled, showInfoTooltip }) {
  const trigger = <span className="special-fare-pill-tooltip-trigger">{pill}</span>;

  if (disabled) {
    return (
      <Tooltip
        key={fareKey}
        title={SPECIAL_FARE_DISABLED_TOOLTIP}
        arrow
        placement="bottom"
        slotProps={SPECIAL_FARE_TOOLTIP_SLOT_PROPS}
      >
        {trigger}
      </Tooltip>
    );
  }
  const tooltip = SPECIAL_FARE_META[fareKey]?.tooltip;
  if (showInfoTooltip && tooltip) {
    return (
      <Tooltip
        key={fareKey}
        title={tooltip}
        arrow
        placement="bottom"
        slotProps={SPECIAL_FARE_TOOLTIP_SLOT_PROPS}
      >
        {trigger}
      </Tooltip>
    );
  }
  return pill;
}

export function SpecialFareInfoIcon({ fareKey, onOpen }) {
  if (!SPECIAL_FARE_META[fareKey]?.tooltip) return null;
  return (
    <IconButton
      type="button"
      size="small"
      aria-label={`More information about ${SPECIAL_FARE_META[fareKey].title} fare`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onOpen(fareKey);
      }}
      sx={{
        p: 0,
        ml: 0.25,
        width: SPECIAL_FARE_INFO_TARGET_PX,
        height: SPECIAL_FARE_INFO_TARGET_PX,
        minWidth: SPECIAL_FARE_INFO_TARGET_PX,
        minHeight: SPECIAL_FARE_INFO_TARGET_PX,
        flexShrink: 0,
        color: 'var(--yovo-grey-700)',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': { color: '#545665', bgcolor: 'rgba(32, 32, 42, 0.04)' },
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: SPECIAL_FARE_INFO_ICON_PX }} />
    </IconButton>
  );
}
